export const widgets = {
  analysis: {
    icon: 'worksheet_column_chart',
    name: _l('统计图'),
  },
  button: {
    icon: 'custom_actions',
    name: _l('按钮'),
  },
  filter: {
    icon: 'filter',
    name: _l('筛选器'),
  },
  carousel: {
    icon: 'slideshow',
    name: _l('轮播图'),
  },
  view: {
    icon: 'view_eye',
    name: _l('视图'),
  },
  richText: {
    icon: 'richtext',
    name: _l('文本'),
  },
  image: {
    icon: 'insert_photo_21',
    name: _l('图片'),
  },
  embedUrl: {
    icon: 'url',
    name: _l('嵌入url'),
  },
};

export const containerWidgets = {
  tabs: {
    icon: 'tab_page',
    name: _l('标签页'),
  },
  card: {
    icon: 'page_card',
    name: _l('卡片'),
  },
};
